import AppHeader from "../../layout/AppHeader";
import Route from "../../xpost/views/umov/route/Route.vue";
import RouteAdd from "../../xpost/views/umov/route/RouteAdd.vue";
import RouteRealTime from "../../xpost/views/umov/route/RouteRealTime.vue";
import CollectHistory from "../../xpost/views/umov/route/CollectHistory.vue";
import RouteRealTimeHistory from "../../xpost/views/umov/route/RouteRealTimeHistory.vue";

const RouteRoutes = [
  {
    path: "/cadastro/rota",
    name: "route",
    components: {
      header: AppHeader,
      default: Route,
    },
  },
  {
    path: "/rota/realtime",
    name: "route.realtime",
    components: {
      header: AppHeader,
      default: RouteRealTime,
    },
  },
  {
    path: "/rota/realtime/historico",
    name: "route.realtime.history",
    components: {
      header: AppHeader,
      default: RouteRealTimeHistory,
    },
  },
  {
    path: "/rota/objetos/historico/:pendency_id",
    name: "route.objects.history",
    components: {
      header: AppHeader,
      default: CollectHistory,
    },
  },
  {
    path: "/cadastro/rota/adicionar",
    name: "route.add",
    components: {
      header: AppHeader,
      default: RouteAdd,
    },
  },
  {
    path: "/cadastro/rota/editar/:id",
    name: "route.edit",
    components: {
      header: AppHeader,
      default: RouteAdd,
    },
  },
];

export default RouteRoutes;
